/**
 * Raporlar ekranının metinleri (M12c Task 18; ADR 0040 #189). Kart adları tasarımdaki gibi
 * (`satin-alma-akisi.jpeg` "Reports").
 */
export const reportsEn = {
  title: 'Reports',
  description: 'Purchasing and stock reports by vessel and period. Export to Excel or PDF.',
  list: 'Reports',
  soon: 'Coming soon',
  soonText: 'This report is being prepared.',
  cards: {
    requisitions: { title: 'Requisition Summary', text: 'Material requisitions and status' },
    orders: { title: 'Purchase Order Report', text: 'PO details and costs' },
    supplierPerformance: { title: 'Supplier Performance', text: 'Delivery time and quality' },
    stock: { title: 'Stock Report', text: 'Current stock levels' },
    consumption: { title: 'Consumption Report', text: 'Usage by vessel and period' },
    costAnalysis: { title: 'Cost Analysis', text: 'Spending by category' },
  },
  view: {
    back: 'Back to reports',
    filters: 'Report filters',
    vessel: 'Vessel',
    allVessels: 'All Vessels',
    status: 'Status',
    allStatuses: 'All Statuses',
    dateRange: 'Date Range',
    from: 'From',
    to: 'To',
    excel: 'Excel',
    pdf: 'PDF',
    loading: 'Loading the report…',
    error: 'The report could not be loaded.',
    empty: 'No records in this period.',
    emptyText: 'Change the period or the filters.',
    table: 'Report rows',
    showing: 'Showing {{from}}-{{to}} of {{total}}',
    pagination: 'Report pages',
    period: '{{from}} – {{to}}',
    stockOn: 'Stock on {{date}}',
    stockDate: 'Stock Date',
    generated: 'Generated {{at}}',
    exportError: 'The file could not be created.',
    summary: 'Summary',
  },
  columns: {
    requisitionNo: 'Requisition No',
    vessel: 'Vessel',
    department: 'Department',
    requestedBy: 'Requested By',
    requestDate: 'Request Date',
    requiredDate: 'Required Date',
    status: 'Status',
    currency: 'Currency',
    total: 'Total',
    poNo: 'PO No',
    orderDate: 'Order Date',
    supplier: 'Supplier',
    expectedDelivery: 'Expected Delivery',
    received: 'Received',
    remaining: 'Remaining',
    material: 'Material',
    category: 'Category',
    unit: 'UOM',
    location: 'Location',
    onHand: 'On Hand',
    minQty: 'Min Stock',
    maxQty: 'Max Stock',
    consumed: 'Consumed',
    adjusted: 'Adjusted',
    movements: 'Movements',
  },
  summary: {
    requisitions: 'Requisitions',
    total: 'Total ({{currency}})',
    unpriced: 'Not in total (unpriced or other currency)',
    orders: 'Purchase orders',
    ordersTotal: 'Ordered ({{currency}})',
    received: 'Received ({{currency}})',
    remaining: 'Remaining ({{currency}})',
    items: 'Stock items',
    low: 'Low stock',
    critical: 'Critical',
    materials: 'Materials',
    movements: 'Movements',
  },
  pdf: {
    footer: 'Generated by Felixmate on {{at}}',
    page: 'Page {{page}} of {{pages}}',
  },
};

export const reportsTr: typeof reportsEn = {
  title: 'Raporlar',
  description: 'Gemi ve döneme göre satın alma ve stok raporları. Excel ya da PDF olarak alın.',
  list: 'Raporlar',
  soon: 'Hazırlanıyor',
  soonText: 'Bu rapor hazırlanıyor.',
  cards: {
    requisitions: { title: 'Talep Özeti', text: 'Malzeme talepleri ve durumları' },
    orders: { title: 'Sipariş Raporu', text: 'Sipariş ayrıntıları ve tutarları' },
    supplierPerformance: { title: 'Tedarikçi Performansı', text: 'Teslim süresi ve kalite' },
    stock: { title: 'Stok Raporu', text: 'Güncel stok seviyeleri' },
    consumption: { title: 'Tüketim Raporu', text: 'Gemi ve döneme göre kullanım' },
    costAnalysis: { title: 'Maliyet Analizi', text: 'Kategoriye göre harcama' },
  },
  view: {
    back: 'Raporlara dön',
    filters: 'Rapor süzgeçleri',
    vessel: 'Gemi',
    allVessels: 'Bütün Gemiler',
    status: 'Durum',
    allStatuses: 'Bütün Durumlar',
    dateRange: 'Tarih Aralığı',
    from: 'Başlangıç',
    to: 'Bitiş',
    excel: 'Excel',
    pdf: 'PDF',
    loading: 'Rapor yükleniyor…',
    error: 'Rapor yüklenemedi.',
    empty: 'Bu dönemde kayıt yok.',
    emptyText: 'Dönemi ya da süzgeçleri değiştirin.',
    table: 'Rapor satırları',
    showing: '{{total}} kayıttan {{from}}-{{to}}',
    pagination: 'Rapor sayfaları',
    period: '{{from}} – {{to}}',
    stockOn: '{{date}} stoğu',
    stockDate: 'Stok Tarihi',
    generated: 'Oluşturulma {{at}}',
    exportError: 'Dosya oluşturulamadı.',
    summary: 'Özet',
  },
  columns: {
    requisitionNo: 'Talep No',
    vessel: 'Gemi',
    department: 'Bölüm',
    requestedBy: 'Talep Eden',
    requestDate: 'Talep Tarihi',
    requiredDate: 'İstenen Tarih',
    status: 'Durum',
    currency: 'Para Birimi',
    total: 'Toplam',
    poNo: 'Sipariş No',
    orderDate: 'Sipariş Tarihi',
    supplier: 'Tedarikçi',
    expectedDelivery: 'Beklenen Teslim',
    received: 'Teslim Alınan',
    remaining: 'Kalan',
    material: 'Malzeme',
    category: 'Kategori',
    unit: 'Birim',
    location: 'Yer',
    onHand: 'Eldeki',
    minQty: 'En Az',
    maxQty: 'En Çok',
    consumed: 'Tüketilen',
    adjusted: 'Düzeltme',
    movements: 'Hareket',
  },
  summary: {
    requisitions: 'Talepler',
    total: 'Toplam ({{currency}})',
    unpriced: 'Toplam dışı (fiyatsız ya da başka para birimi)',
    orders: 'Siparişler',
    ordersTotal: 'Sipariş ({{currency}})',
    received: 'Teslim alınan ({{currency}})',
    remaining: 'Kalan ({{currency}})',
    items: 'Stok kalemleri',
    low: 'Düşük stok',
    critical: 'Kritik',
    materials: 'Malzemeler',
    movements: 'Hareketler',
  },
  pdf: {
    footer: 'Felixmate ile oluşturuldu: {{at}}',
    page: 'Sayfa {{page}} / {{pages}}',
  },
};
